export const VAULT_CLAIM_BADGE_STORAGE_KEY = "vg-vault-storage-full-for-claim";

export const getVaultUpgradeAttentionState = ({
  coins,
  level,
  upgradeStorageCost,
  maxStorageReached,
}) => {
  const coinsValue = Number(coins);
  const storageCost = Number(upgradeStorageCost);

  const canUpgradeStorage =
    !Boolean(maxStorageReached) &&
    Number.isFinite(coinsValue) &&
    Number.isFinite(storageCost) &&
    coinsValue >= storageCost;

  const active = canUpgradeStorage;
  const alertKey = canUpgradeStorage
    ? [Number(level) || 0, storageCost].join(":")
    : "";

  return {
    active,
    allActive: canUpgradeStorage,
    alertKey,
    canUpgradeStorage,
    canUpgradeSpeed: false,
  };
};
